import React, { useState } from "react";
import styled from "styled-components";
import { device, navigateToUrl } from "@helpers";
import NavigationWrapper from "./Navigation";

const Logo = styled.img`
  position: absolute;
  display: block;
  z-index:100;
  cursor: pointer;

  //mobile
  left: 22px;
  top 17px;
  height: 23px;

  @media (min-width: ${device.tablet}) and (max-width: ${device.tabletL}) {
    left: 30px;
    top 30px;
    height: 37px;
  }

  @media (min-width: ${device.laptop}) and (max-width: ${device.desktopS}) {
    left: 31px;
    top 37px;
    height: 37px;
  }

  @media (min-width: ${device.desktopS}) and (max-width: ${device.desktop}) {
    left: 53px;
    top 43px;
    height: 56px;
  }

  @media (min-width: ${device.desktop}) {
    left: 75px;
    top 50px;
    height: 56px;
  }
`;

const StyleAppContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 2560px;
  margin: auto;
`;

const StyleHeaderContainer = styled.div`
  max-width: ${props => (props.background === "none" ? "2560px" : "none")};
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const StyleHeaderInnerWrapper = styled.div`
  position: absolute;
  z-index: 100;

  height: ${props => (props.background === "none" ? "auto" : "3048.9px")};
  width: ${props => (props.background === "none" ? "50%" : "100%")};
  background: ${props =>
    props.background === "none" ? "none" : "rgba(255, 255, 255, 0.7)"};
`;

const Layout = props => {
  const [visible, setVisible] = useState("none");
  let toggleMenu;
  const goHome = e => navigateToUrl(e, "/");
  return (
    <>
      <StyleAppContainer>
        {props && props.logo && (
          <Logo
            alt={props.logo.description}
            src={props.logo.file && props.logo.file && props.logo.file.url}
            onClick={goHome}
          />
        )}
        <StyleHeaderContainer background={visible}>
          <StyleHeaderInnerWrapper background={visible}>
            {props && props.navigationList && (
              <NavigationWrapper
                data={props.navigationList}
                ref={el => {
                  return (toggleMenu = el);
                }}
                onClick={() => {
                  toggleMenu.navOpen();
                  setVisible("block");
                }}
                onClose={() => {
                  toggleMenu.navClose();
                  setVisible("none");
                }}
              />
            )}
          </StyleHeaderInnerWrapper>
        </StyleHeaderContainer>
        {props.children}
      </StyleAppContainer>
    </>
  );
};

export default Layout;
